import React, {Fragment} from "react";
import classNames from 'classnames';
import Col from "react-bootstrap/es/Collapse";
import PropTypes from "prop-types";

class Collapse extends React.Component {

    static propTypes = {
        collapsed: PropTypes.bool,
        button: PropTypes.object,
    }

    state = {}

    constructor(props) {
        super(props);
        this.state.collapsed = this.props.collapsed;
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if(prevProps.collapsed !== this.props.collapsed) {
            this.setState({
                collapsed: this.props.collapsed
            });
        }
    }

    toggleCollapse = (e) => {
        e && e.preventDefault();
        this.setState({
            collapsed: !this.state.collapsed
        })
    }

    render () {
        let button = null;
        if(this.props.button instanceof Object && this.props.button.tag) {
            const Tag = this.props.button.tag || "a";
            button = <Tag className={classNames("btn", this.props.button.className)} onClick={this.toggleCollapse} role="button" data-toggle="collapse">
                {this.props.button.icon} {this.props.button.text}
            </Tag>
        } else if (this.props.button !== undefined && this.props.button !== null) {
            button = React.cloneElement(this.props.button, {...(this.props.button.props || {}), onClick: this.toggleCollapse});
        }
        let ci = this.props.children;
        if (React.Children.count(ci) !== 1) {
            ci = <div>{ci}</div>;
        }
        return (
            <Fragment>
                {button}
                <div className="clearfix"/>
                <Col in={this.state.collapsed}>
                    {ci}
                </Col>
            </Fragment>
        );
    }
}

export default Collapse;